import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// Fetch next serial number for a prefix
export const GetNextSerial = createAsyncThunk(
  "masters/serial/get-next",
  async (prefix, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.Serial_Counter}?prefix=${prefix ||
          ""}`);
      return res; // { serialId, nextNumber }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const SerialSlice = createSlice({
  name: "serial",
  initialState: {
    serialId: "",
    nextNumber: null,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetNextSerial.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetNextSerial.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.serialId = action.payload?.data?.serialId || "";
        state.nextNumber = action.payload?.data?.nextNumber || null;
      })
      .addCase(GetNextSerial.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default SerialSlice.reducer;
